var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffer = function SvgOffer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#offer_svg__a)",
    d: "m15.741 7.155-.603-.896a.7.7 0 0 1-.069-.328l.069-1.086a1.53 1.53 0 0 0-.845-1.466l-.965-.482a.47.47 0 0 1-.225-.225l-.482-.965a1.55 1.55 0 0 0-1.466-.845L10.07.931a.5.5 0 0 1-.31-.086L8.862.259a1.51 1.51 0 0 0-1.69 0l-.896.603a.8.8 0 0 1-.345.069L4.845.862a1.53 1.53 0 0 0-1.466.845l-.482.965a.47.47 0 0 1-.225.225l-.965.482c-.552.276-.88.862-.845 1.466L.931 5.93a.5.5 0 0 1-.086.31l-.586.897a1.51 1.51 0 0 0 0 1.69l.603.896c.052.12.069.224.069.345l-.069 1.086a1.53 1.53 0 0 0 .845 1.466l.965.482a.56.56 0 0 1 .225.225l.482.965c.276.552.862.88 1.466.845l1.086-.069a.5.5 0 0 1 .31.086l.897.586c.259.173.552.259.845.259s.586-.086.845-.259l.896-.603a.65.65 0 0 1 .31-.086l1.087.069a1.53 1.53 0 0 0 1.465-.845l.483-.966a.47.47 0 0 1 .224-.224l.966-.483c.551-.275.879-.862.844-1.465l-.034-1.069a.5.5 0 0 1 .086-.31l.586-.914a1.51 1.51 0 0 0 0-1.69M6.017 3.828A1.92 1.92 0 0 1 7.931 5.74a1.92 1.92 0 0 1-1.914 1.914 1.9 1.9 0 0 1-1.914-1.914 1.92 1.92 0 0 1 1.914-1.913m-.948 7.81a.53.53 0 0 1-.362.155.53.53 0 0 1-.362-.155.5.5 0 0 1 0-.724l6.586-6.57a.5.5 0 0 1 .724 0c.19.208.19.535-.017.725zm4.914.534a1.92 1.92 0 0 1-1.914-1.913 1.92 1.92 0 0 1 1.914-1.914c1.069 0 1.914.845 1.914 1.914a1.92 1.92 0 0 1-1.914 1.913"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "offer_svg__a",
    x1: 0.667,
    x2: 20.667,
    y1: 15.333,
    y2: -4.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE6D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE6D00",
    stopOpacity: 0
  })))));
};
export default SvgOffer;